import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VolunteerRoutingModule } from './volunteer-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    VolunteerRoutingModule
  ]
})
export class VolunteerModule { }
